export const GLOBAL_MAX_WIDTH = 1200;

export const PARTNERS_HEADER_HEIGHT = 56;
